// Entry point for the build script in your package.json
import 'flowbite';
import "@hotwired/turbo-rails"
import "./controllers"
import * as Turbo from '@hotwired/turbo'

import "trix"
import "@rails/actiontext"

import TurboPower from 'turbo_power'
TurboPower.initialize(Turbo.StreamActions)
